import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteData';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20with%20dramatic%20warm%20golden%20and%20crimson%20lighting%2C%20abstract%20movie%20theater%20atmosphere%2C%20Japanese%20and%20Korean%20cinema%20elements%20blending%20elegantly%2C%20rich%20dark%20textured%20background%20with%20soft%20bokeh%20lights%2C%20artistic%20composition%20with%20deep%20shadows%20and%20warm%20highlights%2C%20luxurious%20cinematic%20mood&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
        alt="中文字幕日韩影视大全 - 最全日韩影视资源平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 tracking-wide leading-tight">
          中文字幕日韩影视大全
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          专注<strong>中文字幕日韩</strong>影视资源，涵盖<strong>中文字幕日韩电影</strong>、
          <strong>中文字幕日韩电视剧</strong>、<strong>日韩综艺中文字幕</strong>全品类，
          高清画质配精准中文字幕，海量更新不断档
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white px-7 py-3 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer"
          >
            <i className="ri-play-circle-line text-lg"></i>
            开始观影
          </Link>
          <Link
            to="/category/drama"
            className="inline-flex items-center gap-2 bg-white/15 hover:bg-white/25 text-white border border-white/30 px-7 py-3 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer backdrop-blur-sm"
          >
            <i className="ri-tv-line text-lg"></i>
            日韩电视剧
          </Link>
        </div>
      </div>
    </section>
  );
}